import { Boundaries } from "@planzone/core";
import { id, role } from "@planzone/dto";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { zone }: Boundaries["retrieveZoneRole"]["request"],
): State {
  const index = state.findIndex((req) => req.zone.uuid === zone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          zone,
          request: setRequestStateToPending(),
          role: { uuid: id, ...role },
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          zone,
          request: setRequestStateToPending(),
          role: { uuid: id, ...role },
        },
      ];
}

function handleSuccess(
  state: State,
  { zone, role }: Boundaries["retrieveZoneRole"]["success"],
): State {
  const index = state.findIndex((req) => req.zone.uuid === zone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          zone,
          request: setRequestStateToSuccess(),
          role,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          zone,
          request: setRequestStateToSuccess(),
          role,
        },
      ];
}

function handleFailure(
  state: State,
  { zone }: Boundaries["retrieveZoneRole"]["failure"],
): State {
  const index = state.findIndex((req) => req.zone.uuid === zone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          zone,
          request: setRequestStateToFailure(),
          role: { uuid: id, ...role },
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          zone,
          request: setRequestStateToFailure(),
          role: { uuid: id, ...role },
        },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveZoneRoleRequested]: handleRequest,
    [events.retrieveZoneRoleSucceeded]: handleSuccess,
    [events.retrieveZoneRoleFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
